import { MatPaginatorIntl } from '@angular/material';
export class MatPaginatorIntlNL extends MatPaginatorIntl {
    constructor() {
        super(...arguments);
        this.itemsPerPageLabel = 'Resultaten per pagina';
        this.nextPageLabel = 'Volgende pagina';
        this.lastPageLabel = 'Laatste pagina';
        this.firstPageLabel = 'Eerste pagina';
        this.previousPageLabel = 'Vorige pagina';
        /**
         * Returns the label for the range of items within the current page and the length of the whole list.
         */
        this.getRangeLabel = function (page, pageSize, length) {
            if (length === 0 || pageSize === 0) {
                return '0 van ' + length;
            }
            const maxLength = Math.max(length, 0);
            const startIndex = page * pageSize;
            const endIndex = startIndex < maxLength ? Math.min(startIndex + pageSize, maxLength) : startIndex + pageSize;
            return `${(startIndex + 1)} - ${endIndex} van ${maxLength}`;
        };
    }
}
